import { render, staticRenderFns } from "./ExtendedSearch.vue?vue&type=template&id=d4d3554a&scoped=true"
import script from "./ExtendedSearch.vue?vue&type=script&lang=js"
export * from "./ExtendedSearch.vue?vue&type=script&lang=js"
import style0 from "./ExtendedSearch.vue?vue&type=style&index=0&id=d4d3554a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d3554a",
  null
  
)

export default component.exports